import './index.scss';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import * as Sentry from '@sentry/browser';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_LOGIN_CLIENT_ID } from './global/Environment';
import { initAmplitude } from './utils/analytics/analyticsService';

Sentry.init({
  dsn: 'https://249d62d90acf49c29eb63a64c5b38eee@o307744.ingest.sentry.io/4504489023832064',
  environment: process.env.REACT_APP_ENV,
  beforeSend(event, hint) {
    // If the environment is development, log the error to the console instead of sending it to Sentry
    if (process.env.REACT_APP_ENV === 'development') {
      if (hint?.originalException) {
        console.error(hint.originalException);
      } else {
        console.error(event);
      }
      return null;
    }
    return event;
  }
});

initAmplitude();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <GoogleOAuthProvider clientId={GOOGLE_LOGIN_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);
